import { IconTicket } from '@/assets/icons/IconTicket';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import Order from '@/model/Order';
import Page from '@/model/Page';
import PaymentStatus from '@/model/PaymentStatus';
import dayjs from 'dayjs';
import React, { JSX } from 'react';
import OrderEvent from '@/model/OrderEvent';
import TicketCard from '@/features/tickets/components/CardTicket';

interface ElementStateProps {
  selectedOrder: Order;
}

interface StatusProps {
  orders: Page<Order, Order>;
}

interface DispatchProps {
  onShowDetailTicket: (item: Order) => void;
  onPressTutotialApp: () => void;
}

type TicketsOrderProps = StatusProps & DispatchProps;

export const TicketsOrder: React.FC<TicketsOrderProps> = ({
  orders,
  onShowDetailTicket,
  onPressTutotialApp,
}) => {
  const getPaymentStatus = (status: PaymentStatus): string => {
    let s = '';
    switch (status) {
      case PaymentStatus.APPROVED:
        s = 'Aprovado';
        break;
      case PaymentStatus.DISAPPROVED:
        s = 'Reprovado';
        break;
      case PaymentStatus.AWAITING_PAYMENT:
        s = 'Aguardando Pagamento';
        break;
      case PaymentStatus.CANCELED:
        s = 'Cancelado';
        break;
      case PaymentStatus.CANCELLATION_ANALYSIS:
        s = 'Solicitação de cancelamento em analise';
        break;
      case PaymentStatus.EXPIRED:
        s = 'Expirado';
        break;
      default:
        s = '';
        break;
    }
    return s;
  };

  const getTicketStatus = (selectedOrder: Order): string => {
    let s = 'Disponível';
    if (selectedOrder.paymentStatus === PaymentStatus.CANCELED) {
      s = 'Cancelado';
    } else if (selectedOrder.paymentStatus === PaymentStatus.DISAPPROVED) {
      s = 'Reprovado';
    } else if (selectedOrder.paymentStatus === PaymentStatus.EXPIRED) {
      s = 'Expirado';
    } else if (selectedOrder.paymentStatus === PaymentStatus.AWAITING_PAYMENT) {
      s = 'Aguardando Pagamento';
    } else if (selectedOrder.paymentStatus === PaymentStatus.APPROVED) {
      // eslint-disable-next-line no-plusplus
      for (let e = 0; e < selectedOrder.events.length; e++) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < selectedOrder.events[e].items.length; i++) {
          if (selectedOrder.events[e].items[i].useDate) {
            s = 'Utilizado';
            break;
          } else if (selectedOrder.events[e].items[i].transferDate) {
            s = 'Transferido';
            break;
          }
        }
      }
    }
    return s;
  };

  const ElementStatus: React.FC<ElementStateProps> = ({ selectedOrder }): JSX.Element => {
    const test = getTicketStatus(selectedOrder);
    let classText = 'order-table-tbody-td-child ';

    if (test === 'Disponível') {
      classText += 'bg-status-nao-utilizado ml-2';
    } else if (test === 'Cancelado') {
      classText += 'bg-status-cancelado ml-2';
    } else if (test === 'Transferido') {
      classText += 'bg-status-transferido ml-2';
    } else if (test === 'Aguardando Pagamento') {
      classText += 'bg-status-await ml-2';
    }
    return (
      <div className="order-table-tbody-td-child flex text-center align-middle">
        <span className="font-bold">Status:</span>
        <div className={classText}> {test}</div>
      </div>
    );
  };

  const mountEventName = (events: OrderEvent[]): string | JSX.Element => {
    if (events.length === 1) {
      return events[0].event.name;
    }
    return (
      <>
        {events.map((data, index) => (
          <>
            <span key={`eventNameSpan-${data.event.id}`}>{data.event.name}</span>
            {index < events.length - 1 && <br />}
          </>
        ))}
      </>
    );
  };

  // const actions: ActionProps[] = [
  //   {
  //     title: 'Ver detalhe',
  //     onClick: () => onShowDetailTicket(item),
  //     icon: <IconInfo className="h-[19px]" />,
  //   },
  //   {
  //     title: 'Imprimir',
  //     onClick: () => onShowPrintTicket(item),
  //     icon: <IconTicket className="h-[19px]" />,
  //     hidden: !item.showPrint,
  //   },
  //   {
  //     title: 'Transferir Ingressos',
  //     onClick: () => onShowTransferTicket(item),
  //     icon: <IconTransfer className="h-[22px]" />,
  //     hidden: !item.showTransfer,
  //   },
  //   {
  //     className: 'text-primary-600',
  //     title: 'Cancelar Ingressos',
  //     onClick: () => onShowCancelTicket(item),
  //     icon: <IconClose className="h-[14px] text-primary-600" />,
  //     hidden: !item.showCancel,
  //   },
  // ];

  const dataTicket = orders.list
    ? orders.list.map(item => ({
        id: item.id,
        thumbnail: item.events[0].event.imageUrl,
        name: mountEventName(item.events),
        startDate: dayjs(item.events[0].event.startDate).locale('pt-br').format('DD/MM/YYYY'),
        status: <ElementStatus selectedOrder={item} />,
        statusPayment: (
          <span title={getPaymentStatus(item.paymentStatus)}>
            {getPaymentStatus(item.paymentStatus)}
          </span>
        ),
        option: (
          <React.Fragment>
            <button
              className="text-18 text-center text-gray-600 bg-gray-400 hover:bg-gray-700 text-white font-bold py-2 px-3 mr-2 rounded cursor-pointer"
              onClick={() => onShowDetailTicket(item)}
            >
              Ver Detalhes
            </button>
          </React.Fragment>
        ),
      }))
    : [];

  return (
    <AuthWrapper isHomepage={false}>
      <div className="w-full p-7 md:px-0 container mx-auto py-24">
        <header className="flex flex-wrap items-center mb-[70px]">
          <div className="w-full flex justify-between items-center">
            <div className="flex items-center">
              <IconTicket className="mr-[20px] h-[30px]" />
              <h1 className="font-dmsans font-medium text-[37px]">Meus Pedidos</h1>
            </div>
          </div>
          <p
            className="w-full ml-[25px] items-center text-[18px] font-dmsans font-normal text-blue-600 cursor-pointer"
            onClick={() => onPressTutotialApp()}
          >
            - Como visualizar seu ingresso.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
          {dataTicket.map((item, index) => (
            <TicketCard key={index} ticketData={item} />
          ))}
        </div>
      </div>
    </AuthWrapper>
  );
};
